import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-2" }
const _hoisted_2 = { class: "col-span-10" }
const _hoisted_3 = { class: "col-span-2" }
const _hoisted_4 = { class: "flex flex-col h-full justify-between" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Icon description", -1)
const _hoisted_8 = { class: "flex flex-col" }

import 'vue-advanced-cropper/dist/style.css';
import { Cropper } from 'vue-advanced-cropper';
import { ref, computed, onMounted } from "vue";
import { CheckCircleIcon } from '@heroicons/vue/24/outline';
import { ASPECT_RATIOS } from '@/utils/constants/aspect-ratios';
import CropperIconsComponent from '@/components/global/CropperIconsComponent.vue';

// type CropperComponentInstance = InstanceType<typeof Cropper>;


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCropperComponent',
  props: {
  rawFile: {
    type: String,
    required: true
  }
},
  emits: ['croppedImage'],
  setup(__props, { emit: emits }) {

const props = __props;

const ar = ASPECT_RATIOS;
const cropper = ref<InstanceType <typeof Cropper> | null>(null);





const controls = ref([
  {
    name: 'rotate-anticlockwise',
    icon: 'rotate-anticlockwise',
    action: () => {
      cropper.value?.rotate(-90);
    }
  },
  {
    name: 'rotate-clockwise',
    icon: 'rotate-clockwise',
    action: () => {
      cropper.value?.rotate(90);
    }
  },
  {
    name: 'zoom-in',
    icon: 'zoom-in',
    action: () => {
      cropper.value?.zoom(1.25);
    }
  },
  {
    name: 'zoom-out',
    icon: 'zoom-out',
    action: () => {
      cropper.value?.zoom(0.75);
    }
  },
  {
    name: 'flip-vertical',
    icon: 'flip-vertical',
    action: () => {
      imageFlip(true, false);
    }
  },
  {
    name: 'flip-horizontal',
    icon: 'flip-horizontal',
    action: () => {
      imageFlip(false, true);
    }
  }
])

const change = (data: any) => {
  console.log(data)
}

const imageFlip = (x: boolean, y: boolean) => {
  const image: any  = cropper.value?.getResult().image;

  if (image?.transforms.rotate % 180 !== 0) {
    cropper.value?.flip(!x, !y);
  } else {
    cropper.value?.flip(x, y);
  }
}

const cropImage = () => {
  const canvas: HTMLCanvasElement | undefined = cropper.value?.getResult().canvas;

  canvas?.toBlob((blob: Blob | null) => {
    if (blob) {
      const file = new File([blob], createFileName(), { type: 'image/png' });

      emits('croppedImage', file);
    }
  });
}

const createFileName = (): string => {
  const date = new Date();
  const randomString = Math.random().toString(36).substring(2, 7);

  const fileName = `${date.getTime()}-${randomString}.png`;
  return fileName;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Cropper), {
        ref_key: "cropper",
        ref: cropper,
        src: props.rawFile,
        onChange: change,
        "stencil-props": {
          aspectRatio: _unref(ar).STANDARD
        }
      }, null, 8, ["src", "stencil-props"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controls.value, (control) => {
            return (_openBlock(), _createElementBlock("button", {
              key: control.name,
              onClick: control.action,
              type: "button",
              class: "text-blaze-orange-600 border border-blaze-orange-600 hover:bg-blaze-orange-600 hover:text-white focus:ring-4 focus:outline-none focus:ring-blaze-orange-300 font-medium rounded-lg text-sm p-2.5 text-center flex justify-center items-center dark:border-blaze-orange-500 dark:text-blaze-orange-500 dark:hover:text-white dark:focus:ring-blaze-orange-800 dark:hover:bg-blaze-orange-500"
            }, [
              _createVNode(CropperIconsComponent, {
                type: control.icon
              }, null, 8, ["type"]),
              _hoisted_7
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: cropImage,
            type: "button",
            class: "w-full flex justify-center items-center gap-x-2 rounded-md bg-blaze-orange-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blaze-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blaze-orange-600"
          }, [
            _createVNode(_unref(CheckCircleIcon), {
              class: "-ml-0.5 h-5 w-5",
              "aria-hidden": "true"
            }),
            _createTextVNode(" Crop ")
          ])
        ])
      ])
    ])
  ]))
}
}

})